import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ProductType } from '@tink/core/src/types';
import { captureMessage } from '@tink/core/src/sentry';
import { useHandoffConsumerMachine } from '../hooks/useHandoffConsumerMachine';
import { LoadingOverlay } from '../../core/screens/LoadingOverlay/LoadingOverlay';
import { AuthenticationPromptType, CredentialsEntity } from '../../models/credentials';
import { HandoffCompletedConnected } from '../../components/screens/HandoffCompleted/HandoffCompleted';
import { messages as credentialsMessages } from '../../payments/DirectPayments/components/Flows/messages';
import { CredentialsCopyContext } from '../../components/screens/SubmitCredentials/hooks/useCredentialsCopy';
import { useProduct } from '../../components/ApplicationProviders/ProductProvider/ProductProvider';
import { CredentialsMachineView } from './CredentialsMachineView';

export const HandoffConsumerMachineView = () => {
  const [current, send] = useHandoffConsumerMachine();
  const { productType } = useProduct();
  const { error, provider, credentials } = current.context;
  const onDone = (updatedCredentials: CredentialsEntity) => {
    send({ type: 'MACHINE_DONE_EVENT', credentials: updatedCredentials });
  };

  if (current.matches('APPLICATION_ERROR')) {
    throw error;
  }

  if (current.matches('CREDENTIALS_MACHINE')) {
    let heading;

    // todo find better way of handling product specific copy overrides on handoff mobile side
    if (productType === ProductType.PAY) {
      heading = <FormattedMessage {...credentialsMessages.bankIdPisHeading} />;
    }

    return (
      <CredentialsCopyContext.Provider value={{ heading }}>
        <CredentialsMachineView
          onAuthError={(credentialsError) => {
            captureMessage('Mobile Handoff ended in credentials in error state', {
              custom: { credentialsError: JSON.stringify(credentialsError) },
            });
            onDone(credentialsError);
          }}
          providedCredentials={credentials!}
          onDone={onDone}
          waitForUpdated={false}
          provider={provider!}
          bankIdTarget={AuthenticationPromptType.LOCAL}
          onBack={undefined}
        />
      </CredentialsCopyContext.Provider>
    );
  }

  if (current.matches('HANDOFF_COMPETED')) {
    return <HandoffCompletedConnected />;
  }

  return <LoadingOverlay />;
};
